export const FEEDBACK_SURVEY = 'FEEDBACK_SURVEY';